import { useEffect, useState } from 'react'

export interface EmojiPickerSelection {
    id: string
    name: string
    native: string
    unified: string
    keywords: string[]
    shortcodes: string
}

interface EmojiData {
    categories: Array<{
        id: string
        name: string
        emojis: string[]
    }>
    emojis: Record<string, unknown>
}

export const useEmojiData = () => {
    const [data, setData] = useState<EmojiData | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true)
                const response = await fetch('https://cdn.jsdelivr.net/npm/@emoji-mart/data')
                if (!response.ok) {
                    throw new Error(`Failed to fetch emoji data: ${response.statusText}`)
                }
                const emojiData = await response.json()

                setData(emojiData)
            } catch (err) {
                setError(
                    err instanceof Error ? err : new Error('Unknown error fetching emoji data'),
                )
                console.error('Error loading emoji data:', err)
            } finally {
                setLoading(false)
            }
        }

        loadData()
    }, [])

    return { data, loading, error }
}
